import { Component } from '@angular/core';
import { ContextMenuService } from './context-menu.service';

@Component({
    selector: 'context-menu-holder',
    styles: [ require('./context-menu.scss')],
    host: {
        '(document:click)': 'clickOutside()'
    },
    template: require('./context-menu-holder.html')
})

export class ContextMenuHolderComponent {
    links = [];
    isShown = false;
    private mouseLocation: {left: number, top: number} = {left: 0, top: 0};
    constructor(private menuService: ContextMenuService) {
        menuService.show.subscribe((e) => { this.showMenu(e.event, e.obj); });
    }
    // TODO - Fix this to be responsive
    get menucss(){
        return {
            'position': 'fixed',
            'display': this.isShown ? 'block' : 'none',
            'left': this.mouseLocation.left + 'px',
            'top': this.mouseLocation.top + 'px'
        };
    }

    clickOutside() {
        this.isShown = false;
    }

    showMenu(event, links) {
        this.isShown = true;
        this.links = links;
        this.mouseLocation = {
            left: event.clientX,
            top: event.clientY
        };
    }
}




// WEBPACK FOOTER //
// ./src/common/context-menu/context-menu-holder.component.ts